const getPathNameParts = url => url.pathname.split('/').filter(s => s);

const trimLastPart = parts =>
  parts?.length > 0 ? parts.slice(0, parts.length - 1) : [];

const endsWith = (match, url) => url.pathname.endsWith(match);

module.exports = {
  getPathNameParts,
  trimLastPart,
  endsWith
};
